import SpeechSynthesis from "@/mixins/SpeechSynthesis";
import { navigationNamespace } from "@/store/modules/navigation";
import { mixins } from "vue-class-component";
import { Component } from "vue-property-decorator";
import { Getter } from "vuex-class";

const patientNamespace = { namespace: "patient" };
@Component({})
export default class Alerts extends mixins(SpeechSynthesis) {
  @Getter("alerts", patientNamespace)
  alerts!: any;

  @Getter("helpStep", navigationNamespace)
  step!: number;

  @Getter("towerMode", patientNamespace)
  towerMode!: boolean;

  get hasAudioAlerts() {
    return (
      this.alerts !== null &&
      this.alerts.filter((a: any) => a.message.includes("^^")).length > 0
    );
  }

  get iterableAlerts() {
    const isTower = this.towerMode;

    if (this.alerts) {
      const flattenedAlerts: Record<string, any> = {};
      this.alerts
        .filter((a: any) => a.method >= 1)
        .filter(
          (a: any) =>
            isTower ||
            !(
              a.id.startsWith("CaseReview") ||
              a.id.startsWith("Check") ||
              a.id.startsWith("DNC") ||
              a.id.startsWith("NewIssue") ||
              a.id.startsWith("TowerNote")
            )
        )
        .sort((n1: any, n2: any) =>
          n1.category > n2.category
            ? 1
            : n1.category < n2.category
            ? -1
            : n1.category === n2.category && n1.id > n2.id
            ? 1
            : -1
        )
        .map((a: any) => {
          return {
            category: a.category,
            description: a.description.replace("$", "X").replace("@", "Y"),
            hasAudio: a.message.includes("^^"),
            alertAudio: a.message.includes("^^")
              ? a.message.split("^^")[1]
              : "",
            level: a.level,
            icon: a.icon
          };
        })
        .forEach((element: any) => {
          if (!flattenedAlerts[element.category]) {
            flattenedAlerts[element.category] = [];
          }
          flattenedAlerts[element.category].push(element);
        });
      return flattenedAlerts;
    }
    return false;
  }

  testAlert(alert: string) {
    const text = alert.replace("$", "X").replace("@", "Y");
    this.speak(text);
  }
}
